import { createAction, props } from '@ngrx/store';

const leaveHeadquartersSuccess = createAction(
  '[HqProfessional Effect] Leave headquarters SUCCESS',
  props<{ hqProfessionalId: number }>()
);

export const HqProfessionalLeaveActions = {
  leaveHeadquartersSuccess,
};
